<template>
    <div>
      <a-modal
        v-if="footer"
        :visible="visible"
        :keyboard="false"
        :maskClosable="false"
        :destroyOnClose="true"
        :mask="true"
        :width="width"
        :confirmLoading="loading"
        @cancel="handleCancel"
        @ok="handleOk"
        :okText="okText"
        :cancelText="cancelText"
        :closable="closable"
        :footer="null"
        @afterClose="handleCancel"
      >
        <slot name="content"></slot>
      </a-modal>
      <a-modal
        v-else
        :title="title"
        :visible="visible"
        :maskClosable="false"
        :destroyOnClose="true"
        :mask="true"
        :width="width"
        :confirmLoading="loading"
        @cancel="handleCancel"
        @ok="handleOk"
        :okText="okText"
        :cancelText="cancelText"
        :closable="closable"
        @afterClose="handleCancel"
      >
        <slot name="content"></slot>
        <div slot="footer" v-if="$slots.footer">
          <slot name="footer">
            {{ $t('save') }}
          </slot>
        </div>
      </a-modal>
    </div>
</template>

<script>
  export default {
    name: 'tipModal',
    props:{
      title:{
        type:String,
        required:'',
      },
      visible:{
        type:Boolean,
        default:false,
      },
      loading:{
        type:Boolean,
        default: false,
      },
      closable:{
        type:Boolean,
        default:false
      },
      width:{
        type:Number,
        default:360
      },
      okText:{
        type:String,
        default(){
          return this.$t('baseVO.confirm')
        }
      },
      cancelText:{
        type:String,
        default(){
          return this.$t('baseVO.cacel')
        }
      },
      footer:{
        type: Boolean,
        default: false
      }
    },
    watch:{
      // visible(newValue){
      //     if(newValue){
      //       document.getElementsByTagName('body')[0].classList.add("modalScollHide")
      //     }else{
      //       document.getElementsByTagName('body')[0].classList.remove("modalScollHide")
      //     }
      // }
    },
    data(){
      return{
        bodyStyle:{

        }
      }
    },
    methods:{
      handleOk(){
        this.$emit('ok')
      },
      handleCancel(){
        console.log("close")
        this.$emit('cancel')
      },
    }
  }
</script>